import { GET, POST } from "@/utils/http";

const AUTH_API_BASE = "/auth";
const LEGACY_AUTH_BASE = "/api/auth";

export const AuthService = {
  signIn(request: SignInReq): Promise<SignInRes | null | undefined> {
    return POST<SignInRes>(`${AUTH_API_BASE}/login`, request);
  },
  signOut(): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(`${AUTH_API_BASE}/logout`, {});
  },
  // forgot password remains on legacy auth controller
  forgotPassword(params: any): Promise<SuccessResponse | null | undefined> {
    return GET<SuccessResponse>(
      `${LEGACY_AUTH_BASE}/forgot-password`,
      { params: params },
      true,
    );
  },
  refreshTokenRequest(
    request: RefreshTokenRequest,
  ): Promise<RefreshTokenResponse | null | undefined> {
    return POST<RefreshTokenResponse>(`${AUTH_API_BASE}/refresh`, request);
  },
};
